/**
 * 配置同步（Agent 同步）- 接口定义
 */
import { apiGet, apiPost } from '@/utils/request';
import { parsePaginatedResponse } from '@/utils/apiResponse';
import type {
  AgentSyncExecuteResult,
  AgentSyncPreviewResult,
  AgentSyncRecord,
  AgentSyncRecordDetail,
  AgentSyncRecordStatus,
  AgentSyncRequest,
  AgentSyncSource,
  AgentSyncStrategy,
  AgentSyncStrategyPreview,
} from '@/types/agentSync';

/** 取参考账号的可同步配置（按 agent 类型返回「商家信息」或「店铺知识」组） */
export function queryAgentSyncSource(accountId: number) {
  return apiGet<AgentSyncSource>('/robot-config-sync/source', { account_id: accountId });
}

/** 同步策略效果预览（固定示例内容，供「效果预览」弹窗直接渲染） */
export function queryAgentSyncStrategyPreview() {
  return apiGet<AgentSyncStrategyPreview>('/robot-config-sync/strategy-preview');
}

/** 差异预览（dry-run，不写库） */
export function queryAgentSyncPreview(data: AgentSyncRequest) {
  return apiPost<AgentSyncPreviewResult>('/robot-config-sync/preview', data);
}

/** 发起同步（异步 Job，返回 log_id；进度用记录详情轮询） */
export function executeAgentSync(data: AgentSyncRequest) {
  return apiPost<AgentSyncExecuteResult>('/robot-config-sync/execute', data);
}

/** 同步记录列表（分页 + 筛选；操作人为昵称/账号关键字模糊匹配） */
export function queryAgentSyncRecords(params: {
  page: number;
  page_size: number;
  source_account_id?: number;
  target_account_id?: number;
  strategy?: AgentSyncStrategy;
  status?: AgentSyncRecordStatus;
  operator?: string;
  start_date?: string;
  end_date?: string;
}) {
  return apiGet('/robot-config-sync/records', { ...params }).then((d) =>
    parsePaginatedResponse<AgentSyncRecord>(d),
  );
}

/** 同步记录详情（含本次需同步的配置快照与逐账号明细） */
export function queryAgentSyncRecordDetail(id: number) {
  return apiGet<AgentSyncRecordDetail>(`/robot-config-sync/records/${id}`);
}
